export default __webpack_public_path__ + "static/media/greenCheckCircle.b70355f6.svg";